<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0 justify-content-between d-flex">
                <h5 class="card-title font-bold py-3">تغییر وضعیت</h5>
                <div style="flex: 1"></div>
                <Back
                    v-if="id"
                    url="/admin/sales-management"
                />
            </div>
            <div class="card-body">
                <div class="flex-row justify-content-content mx-5">
                    <h4 v-if="items.length && !returnMode">تنوع های درخواستی فروشنده <b>({{ items[0].seller.full_name }})</b></h4>
                    <h4 class="mb-5" v-else-if="returnMode">تنوع های بازگشتی</h4>
                    
                    <table v-if="items.length && !returnMode" class="table table-responsive-sm table-bordered table-hover">
                        <thead style="background: rgb(192 210 225 / 42%);">
                            <tr>
                                <th>ردیف</th>
                                <th>نام تنوع</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                                <td style="width: 8%;font-weight: bold;">{{ index + 1 }}</td>
                                <td>{{ item.var_name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <form class="mt-3" @submit.prevent="submit">
                        <h4 v-if="returnMode" class="font-weight-bold">بازگشت تنوع</h4>
                        <h4 v-else class="font-weight-bold">ارسال تنوع</h4>
                        <b-form-group label="انتخاب محصول">
                            <div class="d-flex col-md-6" style="gap: 0.5rem">
                                <b-form-input autocomplete="off" autofocus ref="productSku" v-model="productSku"
                                    @keypress.prevent.enter="requestProduct" :disabled="disabled" type="text" />
                            </div>
                        </b-form-group>
                        <table v-if="varieties && varieties.length"
                            class="table table-responsive-sm table-bordered table-hover">
                            <thead style="background: rgb(114 175 225 / 24%);">
                                <tr>
                                    <th>ردیف</th>
                                    <th>نام تنوع</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(variety, index) in varieties" :key="index">
                                    <td style="width: 8%;font-weight: bold;">{{ index + 1 }}</td>
                                    <td>{{ variety.variety_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="mt-4 w-100 d-flex justify-content-center">
                            <button type="submit" v-if="returnMode" :disabled="DiasableSubmit"
                                :class="{ reqDiasableStyle: DiasableSubmit }" class="btn btn-danger">
                                برگشت تنوع ها
                            </button>
                            <button type="submit" v-else :disabled="DiasableSubmit"
                                :class="{ reqDiasableStyle: DiasableSubmit }" class="btn btn-success">
                                ارسال تنوع ها
                            </button>
                        </div>
                    </form>
                    <Loading v-if="$root.isEmptyObject(items)" />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ChangeStatusImpl from "@@/core/pages/SalesManagement/SalesManagementChangeStatus/ChangeStatusImpl";
export default {
    extends: ChangeStatusImpl,
};
</script>
<style src="@@/core/pages/SalesManagement/SalesManagementChangeStatus/ChangeStatusStyle.css"></style>